import React from 'react';
import { useSelector } from 'react-redux';

import { Sidecar } from '@swf/poker';

import { usePokerSundayMillionWidget } from '../../../../model';

const SidecarContainer: React.FC = () => {
  const { widgetSelect } = usePokerSundayMillionWidget();
  const tournament = useSelector(widgetSelect.getSelectedTournament);

  if (!tournament) return <Sidecar.Empty />;

  return <Sidecar tournament={tournament} showRegisterButton={false} showLobbyButton />;
};

export default SidecarContainer;
